import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled, Box, Grid } from '@mui/material';

export const BaseOnLabel = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

export const BaseOnRadio = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
    '& .MuiIconButton-root': {
        paddingTop: 0,
        paddingRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
        margin: theme.spacing(1, 0),
    },
}));

export const BaseOnText = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
}));

export const IntegrationBaseOn = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const OftenTitle = styled(GivelifyLabel)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

export const NotificationCheckBox = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
    },
    marginTop: theme.spacing(4),
}))

export const F1Step = styled(Grid)(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(4),
    position: 'relative',
}));

export const F1StepImage = styled('div')({
    width: 100,
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    background: '#EFF4F9',
    margin: '0 auto 32px',
});

export const F1StepTitle = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const StepLink = styled('div')(({ theme }) => ({
    border: `2px solid #EFF4F9`,
    width: 86,
    position: 'absolute',
    top: 82,
    right: '-40px',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));